export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  tags: string[];
  views: string;
  rating: number;
  chapters: number;
  status: string;
  update: string;
  description: string;
  cover: string;
}

export const categories: { name: string; icon: string; desc: string }[] = [
  { name: "现代恋爱", icon: "ri-heart-3-line", desc: "都市心动日常" },
  { name: "重生逆袭", icon: "ri-refresh-line", desc: "逆风翻盘人生" },
  { name: "都市霸总", icon: "ri-briefcase-4-line", desc: "豪门爱恨纠葛" },
  { name: "奇幻穿越", icon: "ri-sparkling-2-line", desc: "异世冒险奇缘" },
  { name: "校园甜宠", icon: "ri-graduation-cap-line", desc: "青春青涩悸动" },
  { name: "豪门情仇", icon: "ri-vip-crown-2-line", desc: "恩怨情仇博弈" },
  { name: "古风宫斗", icon: "ri-sword-line", desc: "深宫权谋大戏" },
  { name: "轻松搞笑", icon: "ri-emotion-happy-line", desc: "爆笑解压日常" },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: "总裁的替嫁新娘",
    author: "白鹿漫画社",
    category: "现代恋爱",
    tags: ["甜宠", "契约婚姻", "HE"],
    views: "328.6万",
    rating: 9.6,
    chapters: 218,
    status: "连载中",
    update: "今日 08:32 更新",
    description:
      "被迫替嫁的灰姑娘撞上冷面总裁，一场各取所需的契约婚姻，却在朝夕相处中暗生情愫。他以为她是任人拿捏的替身，直到她亮出真容，彻底颠覆了整个豪门的棋盘。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20illustration%20of%20a%20romantic%20modern%20drama%20between%20a%20handsome%20young%20ceo%20in%20a%20suit%20and%20an%20elegant%20bride%20in%20a%20white%20wedding%20dress%2C%20vibrant%20anime%20manhwa%20style%2C%20soft%20warm%20amber%20gradient%20background%2C%20clean%20polished%20digital%20illustration%2C%20cinematic%20romantic%20lighting%2C%20high%20quality&width=600&height=800&seq=comic-01&orientation=portrait",
  },
  {
    id: 2,
    title: "重生后我成了全家团宠",
    author: "云端工作室",
    category: "重生逆袭",
    tags: ["重生", "团宠", "爽文"],
    views: "412.3万",
    rating: 9.8,
    chapters: 189,
    status: "连载中",
    update: "今日 07:50 更新",
    description:
      "上一世受尽冷眼的她带着记忆重生，这一世不再隐忍，用预知未来的金手指一步步逆袭，收获全家人的宠爱与男主人的忠犬守护，活成了所有人都羡慕的模样。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20confident%20young%20woman%20with%20glowing%20golden%20magic%20energy%20in%20her%20hands%2C%20surrounded%20by%20warm%20cherishing%20family%20members%2C%20vibrant%20manhwa%20anime%20style%2C%20soft%20peach%20and%20gold%20gradient%20background%2C%20clean%20polished%20digital%20illustration%2C%20hopeful%20bright%20lighting%2C%20high%20quality&width=600&height=800&seq=comic-02&orientation=portrait",
  },
  {
    id: 3,
    title: "我的隔壁是影帝",
    author: "青柠画坊",
    category: "现代恋爱",
    tags: ["娱乐圈", "欢喜冤家", "甜文"],
    views: "256.1万",
    rating: 9.4,
    chapters: 142,
    status: "已完结",
    update: "昨日 21:40 更新",
    description:
      "新搬来的邻居竟是人气影帝，日常互怼、互相拆台的两人，在狗仔偷拍与绯闻发酵中渐渐靠近。当聚光灯照进平凡生活，这份感情能否抵挡流言蜚语？",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20charming%20celebrity%20actor%20in%20sunglasses%20holding%20a%20coffee%20and%20a%20casual%20girl%20neighbor%20bickering%20playfully%2C%20vibrant%20manhwa%20romance%20style%2C%20warm%20sunset%20orange%20gradient%20background%2C%20clean%20digital%20illustration%2C%20lively%20lighting%2C%20high%20quality&width=600&height=800&seq=comic-03&orientation=portrait",
  },
  {
    id: 4,
    title: "吸血鬼少爷的契约",
    author: "墨色工坊",
    category: "奇幻穿越",
    tags: ["吸血鬼", "契约", "奇幻"],
    views: "198.7万",
    rating: 9.2,
    chapters: 106,
    status: "连载中",
    update: "今日 06:20 更新",
    description:
      "误入异世的少女与高冷吸血鬼少爷缔结血之契约，为了生存她必须成为他的侍从。神秘古堡、禁忌魔法与暗藏的秘密，一场跨越种族的爱恋就此展开。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20pale%20elegant%20vampire%20prince%20in%20a%20dark%20coat%20and%20a%20brave%20human%20girl%2C%20moonlight%20castle%20background%2C%20vibrant%20manhwa%20fantasy%20style%2C%20deep%20maroon%20and%20warm%20gold%20moody%20lighting%2C%20dramatic%20atmosphere%2C%20high%20quality%20digital%20illustration&width=600&height=800&seq=comic-04&orientation=portrait",
  },
  {
    id: 5,
    title: "转生成为恶女的宿敌",
    author: "星河漫绘",
    category: "奇幻穿越",
    tags: ["转生", "反派", "逆袭"],
    views: "301.5万",
    rating: 9.5,
    chapters: 165,
    status: "连载中",
    update: "今日 09:05 更新",
    description:
      "穿越成小说里人人喊打的恶毒女配，她果断抛弃剧本，联手宿敌男主改写命运。一边攻略高冷男主，一边打脸白莲花女主，权谋与浪漫双重buff拉满。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20fierce%20elegant%20villainess%20lady%20and%20a%20cold%20handsome%20male%20lead%20standing%20back%20to%20back%2C%20royal%20fantasy%20palace%2C%20vibrant%20manhwa%20style%2C%20rich%20crimson%20and%20amber%20gradient%20background%2C%20dramatic%20lighting%2C%20clean%20polished%20digital%20illustration%2C%20high%20quality&width=600&height=800&seq=comic-05&orientation=portrait",
  },
  {
    id: 6,
    title: "甜蜜陷阱：总裁追妻火葬场",
    author: "暖阳漫画",
    category: "都市霸总",
    tags: ["追妻", "火葬场", "虐甜"],
    views: "354.9万",
    rating: 9.7,
    chapters: 203,
    status: "连载中",
    update: "今日 08:00 更新",
    description:
      "曾经亲手推开她的高冷总裁，如今却放下身段疯狂追妻。昔日种种伤害化为甜蜜陷阱，他步步紧追，她转身离开，一场烧心又上头的虐恋大战正式打响。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20remorseful%20handsome%20ceo%20holding%20flowers%20chasing%20an%20elegant%20angry%20woman%20turning%20away%2C%20city%20skyline%20at%20dusk%2C%20vibrant%20manhwa%20romance%20style%2C%20warm%20rose%20and%20orange%20gradient%20background%2C%20clean%20digital%20illustration%2C%20cinematic%20lighting%2C%20high%20quality&width=600&height=800&seq=comic-06&orientation=portrait",
  },
  {
    id: 7,
    title: "电竞大神的小迷妹",
    author: "柚子工作室",
    category: "校园甜宠",
    tags: ["电竞", "双向暗恋", "甜文"],
    views: "176.3万",
    rating: 9.1,
    chapters: 98,
    status: "已完结",
    update: "前天 20:15 更新",
    description:
      "学校电竞社的大神学长，是学妹心中仰望的存在。一次机缘巧合的组队，两人从并肩作战到暗生情愫，青春校园里最甜的双向奔赴悄然上演。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20cool%20e-sports%20prodigy%20boy%20wearing%20headset%20and%20a%20cute%20admiring%20schoolgirl%20with%20sparkling%20eyes%2C%20vibrant%20manhwa%20campus%20style%2C%20soft%20pastel%20peach%20and%20cream%20gradient%20background%2C%20fresh%20bright%20lighting%2C%20clean%20polished%20digital%20illustration%2C%20high%20quality&width=600&height=800&seq=comic-07&orientation=portrait",
  },
  {
    id: 8,
    title: "重生医妃不好惹",
    author: "云裳画社",
    category: "古风宫斗",
    tags: ["古代", "医妃", "宫斗"],
    views: "267.8万",
    rating: 9.3,
    chapters: 176,
    status: "连载中",
    update: "今日 10:12 更新",
    description:
      "医女重生归来，带着一身绝技入主东宫。面对后宫明枪暗箭与权贵倾轧，她以医术立威、以智谋自保，一路逆袭成不可撼动的传奇医妃。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20an%20elegant%20ancient%20Chinese%20royal%20consort%20in%20hanfu%20holding%20medical%20herbs%2C%20serene%20palace%20garden%2C%20vibrant%20manhwa%20historical%20drama%20style%2C%20warm%20jade%20and%20amber%20gradient%20background%2C%20refined%20ornate%20details%2C%20clean%20digital%20illustration%2C%20high%20quality&width=600&height=800&seq=comic-08&orientation=portrait",
  },
  {
    id: 9,
    title: "王牌特工的软萌日常",
    author: "闪电漫记",
    category: "轻松搞笑",
    tags: ["搞笑", "反差萌", "日常"],
    views: "145.2万",
    rating: 9.0,
    chapters: 87,
    status: "连载中",
    update: "今日 05:45 更新",
    description:
      "冷血王牌特工退隐后，成了菜市场里人见人爱的软萌摊主。白天卖菜，夜里抓坏人，无敌反差萌笑料不断，日常又热血的欢乐故事轻松开读。",
    cover: "https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20cute%20soft%20elite%20agent%20in%20an%20apron%20selling%20vegetables%20at%20a%20market%20stall%2C%20vibrant%20manhwa%20comedy%20style%2C%20cheerful%20warm%20yellow%20and%20orange%20gradient%20background%2C%20playful%20fun%20mood%2C%20clean%20polished%20digital%20illustration%2C%20high%20quality&width=600&height=800&seq=comic-09&orientation=portrait",
  },
];

export const updates = [
  { id: 1, title: "总裁的替嫁新娘", episode: "第218话 真相大白", category: "现代恋爱", time: "刚刚", hot: true },
  { id: 2, title: "重生后我成了全家团宠", episode: "第189话 家的温度", category: "重生逆袭", time: "12分钟前", hot: true },
  { id: 3, title: "甜蜜陷阱：总裁追妻火葬场", episode: "第203话 我的答案", category: "都市霸总", time: "38分钟前", hot: true },
  { id: 4, title: "转生成为恶女的宿敌", episode: "第165话 联手", category: "奇幻穿越", time: "1小时前", hot: false },
  { id: 5, title: "重生医妃不好惹", episode: "第176话 入主东宫", category: "古风宫斗", time: "2小时前", hot: false },
  { id: 6, title: "吸血鬼少爷的契约", episode: "第106话 血月之夜", category: "奇幻穿越", time: "3小时前", hot: false },
];

export const rankings = [
  { rank: 1, title: "重生后我成了全家团宠", category: "重生逆袭", views: "412.3万", trend: "up" },
  { rank: 2, title: "甜蜜陷阱：总裁追妻火葬场", category: "都市霸总", views: "354.9万", trend: "up" },
  { rank: 3, title: "总裁的替嫁新娘", category: "现代恋爱", views: "328.6万", trend: "flat" },
  { rank: 4, title: "转生成为恶女的宿敌", category: "奇幻穿越", views: "301.5万", trend: "up" },
  { rank: 5, title: "重生医妃不好惹", category: "古风宫斗", views: "267.8万", trend: "down" },
  { rank: 6, title: "我的隔壁是影帝", category: "现代恋爱", views: "256.1万", trend: "flat" },
  { rank: 7, title: "吸血鬼少爷的契约", category: "奇幻穿越", views: "198.7万", trend: "up" },
  { rank: 8, title: "电竞大神的小迷妹", category: "校园甜宠", views: "176.3万", trend: "down" },
];

export const faqs = [
  {
    q: "韩漫免费无删减是什么意思？",
    a: "本站主打韩漫免费无删减下拉式阅读，即无需付费即可连续下拉浏览完整章节内容，画面与对白保持原汁原味，章节齐全、连贯不中断，让读者获得顺畅的追更体验。",
  },
  {
    q: "看韩漫免费全集需要注册或付费吗？",
    a: "不需要。本站的全部韩漫免费内容均无需注册登录，点开即可直接阅读。读者可以免费看全集、收藏追更，随时随地享受高清韩漫免费阅读体验。",
  },
  {
    q: "韩漫免费下拉阅读支持哪些设备？",
    a: "站内阅读页面针对手机、平板与电脑进行了全面适配，支持手指下拉与鼠标滚动两种方式，横屏竖屏都能流畅阅读，随时随地畅享高清韩漫免费阅读。",
  },
  {
    q: "多久更新一次，如何及时追更？",
    a: "网站每日定时更新热门韩漫与章节内容，首页设有每日更新榜单与追更提醒，将喜欢的故事加入收藏即可第一时间收到新章节上线的消息。",
  },
  {
    q: "遇到章节加载慢或图片不显示怎么办？",
    a: "可先尝试切换网络或刷新页面；若仍无法显示，请检查浏览器缓存并清除后再试。若问题依旧，可通过页面底部联系方式反馈，我们会尽快处理。",
  },
];